<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row class="mb-3">
          <b-col cols="6" class="mt-1">
            <h4>{{ $t('global.users_list_title') }}</h4>
          </b-col>
          <b-col cols="6">
            <div class="pull-right">
              <b-button variant="primary" class="mt-1" :to="{ name: 'UserCreate' }">
                {{ $t('global.user_create_new') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col>
            <b-checkbox v-model="filters.expired_subscription">
              Users with expired subscriptions.
            </b-checkbox>
          </b-col>
        </b-row>
        <div v-if="spinners.contentIsLoading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col cols="12">
              <b-table class="table-sm text-center" responsive bordered :fields="tableFields" :items="tableItems">
                <template v-slot:cell(is_active)="item">
                  <b-badge v-if="item.value" variant="success">
                    {{ $t('global.active') }}
                  </b-badge>
                  <b-badge v-if="!item.value" variant="secondary">
                    {{ $t('global.inactive') }}
                  </b-badge>
                </template>
                <template v-slot:cell(options)="row">
                  <b-spinner v-if="spinners.isSaving === row.item.id"
                    type="grow" variant="primary" class="mr-3" small/>
                  <span v-if="spinners.isSaving">
                      <a v-if="!row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3">
                        <i class="fa fa-unlock-alt fa-lg fa-disabled"/>
                      </a>
                      <a v-if="row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3">
                        <i class="fa fa-ban fa-lg fa-disabled"/>
                      </a>
                    </span>
                  <span v-else>
                      <a v-if="!row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3"
                        @click="changeUserActive(row.item.id, true)">
                        <i class="fa fa-unlock-alt fa-lg fa-success"/>
                      </a>
                      <a v-if="row.item.is_active && spinners.isSaving !== row.item.id" class="mr-3"
                        @click="changeUserActive(row.item.id, false)">
                        <i class="fa fa-ban fa-lg fa-danger"/>
                      </a>
                    </span>
                  <router-link :to="{ name: 'UserUpdate', params:{id: row.item.id}}">
                    <a><i class="fa fa-edit fa-lg"/></a>
                  </router-link>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator-->
            <b-col cols="12" v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import statuses from '@/store/statuses';
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import VT from '@/store/types';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      spinners: {
        contentIsLoading: true,
        isSaving: false,
      },
      tableFields: [
        { key: 'id', label: this.$t('global.id') },
        { key: 'name', label: this.$t('global.name') },
        { key: 'surname', label: this.$t('global.surname') },
        { key: 'email', label: this.$t('global.email') },
        { key: 'phone', label: this.$dt('global.phone', 'Phone') },
        { key: 'created_at', label: this.$t('global.created_at') },
        { key: 'updated_at', label: this.$t('global.updated_at') },
        { key: 'is_active', label: this.$t('global.active') },
        { key: 'options', label: this.$t('global.options') }
      ],
      tableItems: [],
      filters: {
        expired_subscription: false,
      },
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapGetters('Users', [
      'usersList',
      'userUpdateActive'
    ]),
    listPaginator() {
      return this.usersList.data.meta;
    },
    list() {
      return this.usersList;
    }
  },
  watch: {
    page: 'getData',
    listPaginator: {
      handler: function () {
        if (this.listPaginator && this.listPaginator.last_page < this.page) {
          this.onPageChange(this.listPaginator.last_page);
        }
      },
      deep: true
    },
    list: {
      handler: function () {
        if (this.list['status'] === statuses.LOADED) {
          this.tableItems = this.list.data.data || [];
          this.spinners.contentIsLoading = false;
        }
      },
      deep: true
    },
    filters: {
      handler: function () {
        this.getData();
      },
      deep: true
    },
    userUpdateActive: {
      handler: function () {
        this.spinners.isSaving = false;
        if (this.userUpdateActive.status === statuses.LOADED) {
          this.alertSuccess();
          this.getData();
        } else if (this.userUpdateActive.status === statuses.ERROR) {
          this.alertError();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions('Users', [
      VT.USERS_LIST,
      VT.USER_UPDATE_ACTIVE,
    ]),
    getData() {
      this.USERS_LIST({ 
        ...this.filters,
        page: this.page, 
        expired_subscription: this.filters.expired_subscription ? 1 : 0,
      });
    },
    onPageChange(page) {
      if (!page) {
        page = this.page;
      }
      if (page !== this.page) {
        this.$router.push({ name: 'Users', params: { page } });
      }
    },
    changeUserActive(id, isActive) {
      this.spinners.isSaving = id;
      this.USER_UPDATE_ACTIVE({ id, isActive });
    }
  }
};
</script>

<style scoped>
</style>
